import { useLocation } from 'react-router'

const useQueryParams = function () {
    return new URLSearchParams(useLocation().search)
}

export default useQueryParams
